const depositPlans = [
  {
    id: '',
    name: '選択なし'
  },
  {
    id: 1,
    name: '購入日の翌月振込'
  },
  {
    id: 2,
    name: '利用日の翌月振込'
  },
  {
    id: 3,
    name: 'Stripe（4~10日）'
  },
  {
    id: 4,
    name: 'Stripe（30~36日）'
  }
];

export default depositPlans;
